module.exports = __webpack_public_path__ + "static/empauqes-b391b6b5e00a6a055017e569ec068c31.png";